import React from 'react';
import { object, number, arrayOf, bool, string } from 'prop-types';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';
import { waypointPropTypes } from '../../../proptypes/shared';
import WaypointsSection from '../WaypointsSection';
import { useWaypoints } from '../../../hooks/useWaypoints';

const WaypointsWrapper = ({ waypoints, canEdit, messagingChannel, mapId, trailId, isAdmin, className }) => {
  const [waypointsState, dispatchWaypoints] = useWaypoints({ initialWaypoints: waypoints, messagingChannel, canEdit });

  return (
    <div className={classNames(styles.container, [className])}>
      <WaypointsSection
        {...waypointsState}
        dispatchWaypoints={dispatchWaypoints}
        messagingChannel={messagingChannel}
        mapId={mapId}
        canEdit={canEdit}
        trailId={trailId}
        isAdmin={isAdmin}
      />
    </div>
  );
};

WaypointsWrapper.propTypes = {
  messagingChannel: object,
  trailId: number,
  waypoints: arrayOf(waypointPropTypes),
  canEdit: bool,
  mapId: number,
  isAdmin: bool,
  className: string
};

WaypointsWrapper.defaultProps = {
  messagingChannel: null,
  trailId: null,
  waypoints: [],
  canEdit: false,
  mapId: null,
  isAdmin: false,
  className: ''
};

export default WaypointsWrapper;
